import type { SessionType } from '@/types'

export const session: SessionType[] = [
  {
    id: 1,
    browser: 'Mac OS (Safari)',
    near: 'MX, Xcanatun',
    ip: '200.68.172.10',
    lastUse: 'Online',
    action: 'Current Session',
  },
  {
    id: 2,
    browser: 'Mac OS (Safari)',
    near: 'MX, Xcanatun',
    ip: '200.68.172.10',
    lastUse: 'Online',
    action: 'Current Session',
  },
  {
    id: 3,
    browser: 'Mac OS (Safari)',
    near: 'MX, Xcanatun',
    ip: '200.68.172.10',
    lastUse: 'Online',
    action: 'Current Session',
  },
]
